const userAgent = window.navigator.userAgent;

// TODO JWA can we remove this completely?

export const isChrome: boolean =
  /chrome/i.test(userAgent) && /google/i.test(navigator.vendor);
export const isFirefox: boolean = /firefox/i.test(userAgent);
